import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 8h1v8","key":"svg-0"}],["path",{"d":"M13 8v3a1 1 0 0 0 1 1h3","key":"svg-1"}],["path",{"d":"M17 8v8","key":"svg-2"}]]

const IconNumber14Small = createReactComponent('outline', 'number-14-small', 'Number14Small', __iconNode);

export default IconNumber14Small;